import { Box, Button, Grid, styled, Typography } from "@mui/material";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import * as React from "react";
import { useEffect, useState } from "react";
import useFetchAllPendidikan from "../../../../api/effects/queries/Pendidikan/useFetchAllPendidikan";
import useFetchAllPertanyaan from "../../../../api/effects/queries/Pertanyaan/useFetchAllPertanyaan";
import { PendidikanResponse } from "../../../../models/Pendidikan";
import { PertanyaanResponse } from "../../../../models/Pertanyaan";
import { CustomToolbar } from "../../HeaderHR";
import PertanyaanModal from "./PertanyaanModal";

const BoxTable = styled(Box)({
  maxWidth: "1280px",
  height: "70vh",
  width: "100%",
});

export default function PertanyaanTable() {
  const columns: GridColDef[] = [
    {
      field: "PERTANYAAN_ID",
      headerName: "Pertanyaan ID",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    { field: "PERTANYAAN", headerName: "Pertanyaan", flex: 1 },
    { field: "TIPE_PERTANYAAN", headerName: "Tipe Pertanyaan", flex: 1 },
    {
      field: "IS_ACTIVE",
      headerName: "Is Active",
      type: "boolean",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      renderCell: (params: GridValueGetterParams) => {
        const onClick = () => {
          handleOpenModalEdit(params.row.PERTANYAAN_ID);
        };
        return <Button onClick={onClick}>Edit</Button>;
      },
      headerAlign: "center",
      align: "center",
    },
  ];
  const { data: allPertanyaanData } = useFetchAllPertanyaan();

  const [data, setData] = useState<PertanyaanResponse[]>();

  useEffect(() => {
    if (allPertanyaanData !== undefined) {
      setData(allPertanyaanData);
    }
  }, [allPertanyaanData]);

  const [IDState, setIDState] = useState(-1);
  const [modalState, setModalState] = useState(false);

  const handleOpenModalAdd = () => {
    setIDState(-1);
    setModalState(!modalState);
  };
  const handleOpenModalEdit = (e: number) => {
    setIDState(e);
    setModalState(!modalState);
  };

  const handleCloseModal = () => {
    setModalState(!modalState);
  };

  return (
    <>
      <PertanyaanModal
        open={modalState}
        handleClose={handleCloseModal}
        ID={IDState}
      />
      <Grid
        container
        justifyContent="flex-start"
        sx={{
          maxWidth: "1280px",
          paddingBottom: "1vh",
        }}
      >
        <Typography variant="h4">Tabel Pertanyaan</Typography>
      </Grid>
      <BoxTable>
        {data !== undefined ? (
          <DataGrid
            rows={data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            getRowId={(data) => data.PERTANYAAN_ID}
            disableColumnMenu
            components={{ Toolbar: CustomToolbar }}
          />
        ) : (
          <div />
        )}
      </BoxTable>

      <Grid
        container
        justifyContent="flex-end"
        sx={{
          maxWidth: "1280px",
          paddingTop: "2vh",
        }}
      >
        <Button variant="contained" onClick={handleOpenModalAdd}>
          Tambah Pertanyaan
        </Button>
      </Grid>
    </>
  );
}
